import { render, staticRenderFns } from "./NotificationDate.vue?vue&type=template&id=950c271a&scoped=true"
import script from "./NotificationDate.vue?vue&type=script&lang=js"
export * from "./NotificationDate.vue?vue&type=script&lang=js"
import style0 from "./NotificationDate.vue?vue&type=style&index=0&id=950c271a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "950c271a",
  null
  
)

export default component.exports